import React from 'react'
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { useKeycloak } from '@react-keycloak/web'
import { ContractSelect } from 'pages'
import { ContextLoader } from 'components'

export function RouteWrapper({
  privateRoute,
  component,
  layout: Layout,
  path,
  ignoreSelectContract,
  ignoreKeycloak,
  ...props
}) {
  const { keycloak, initialized } = useKeycloak()
  const { selected: selectedContract } = useSelector(({ contract }) => contract)
  const renderPage = ignoreSelectContract || !!selectedContract
  const hasSessionTime = localStorage.getItem('SUMICITY_SESSION_TIME')

  function renderLayoutPage(page) {
    if (!Layout) return <Route component={page} {...props} />

    return (
      <Layout>
        <Route component={page} {...props} />
      </Layout>
    )
  }

  if (!initialized) return <ContextLoader />

  if (!privateRoute) return renderLayoutPage(component)

  if (!keycloak.authenticated) {
    keycloak.login()

    return null
  }

  if (!hasSessionTime) localStorage.setItem('SUMICITY_SESSION_TIME', Date.now())

  const page = renderPage ? component : ContractSelect
  return renderLayoutPage(page)
}
